import {ActivityNotificationStatus, IActivityNotification} from "./activity-notification";
import {Utils} from "../shared/utils/utils";
import {ActivityAction} from "../activities/activity";

export class ActivityNotificationMapper {

  public static activityNotificationMessages = {
    'update_user_data_pending': 'Updating user data.',
    'update_user_data_running': 'Updating user data.',
    'update_user_data_done': 'User data updated.',
    'update_user_data_failed': 'Failed to update user data.',
    'update_user_data_canceled': 'Updating user data is canceled.',
    'add_website_pending': 'Adding <strong>{{websiteTitle}}</strong>.',
    'add_website_running': 'Adding <strong>{{websiteTitle}}</strong>.',
    'add_website_done': '<strong>{{websiteTitle}}</strong> added.',
    'add_website_failed': 'Failed to add <strong>{{websiteTitle}}</strong>.',
    'add_website_canceled': 'Adding <strong>{{websiteTitle}}</strong> is canceled.',
    'migrate_website_pending': 'Migrating <strong>{{websiteTitle}}</strong>.',
    'migrate_website_running': 'Migrating <strong>{{websiteTitle}}</strong>.',
    'migrate_website_done': '<strong>{{websiteTitle}}</strong> migrated.',
    'migrate_website_failed': 'Failed to migrate <strong>{{websiteTitle}}</strong>.',
    'migrate_website_canceled': 'Migrating <strong>{{websiteTitle}}</strong> is canceled.',
    'create_website_pending': 'Creating <strong>{{websiteTitle}}</strong>.',
    'create_website_running': 'Creating <strong>{{websiteTitle}}</strong>.',
    'create_website_done': '<strong>{{websiteTitle}}</strong> created.',
    'create_website_failed': 'Failed to create <strong>{{websiteTitle}}</strong>.',
    'create_website_canceled': 'Creating <strong>{{websiteTitle}}</strong> is canceled.',
    'staging_website_create_pending': 'Enabling staging environment',
    'staging_website_create_running': 'Enabling staging environment',
    'staging_website_create_done': '<strong>Staging environment for {{websiteTitle}}</strong> is enabled.',
    'staging_website_create_failed': 'Failed to enable staging environment for <strong>{{websiteTitle}}</strong>.',
    'staging_website_create_canceled': 'Enabling of staging environment for <strong>{{websiteTitle}}</strong> is canceled.',
    'staging_website_delete_pending': 'Disabling staging environment for <strong>{{websiteTitle}}</strong>.',
    'staging_website_delete_running': 'Disabling staging environment for <strong>{{websiteTitle}}</strong>.',
    'staging_website_delete_done': '<strong>Staging environment for {{websiteTitle}}</strong> is disabled.',
    'staging_website_delete_failed': 'Failed to disable staging environment for <strong>{{websiteTitle}}</strong>.',
    'staging_website_delete_canceled': 'Disabling of staging environment for <strong>{{websiteTitle}}</strong> is canceled.',
    'remove_website_pending': 'Removing <strong>{{websiteTitle}}</strong>.',
    'remove_website_running': 'Removing <strong>{{websiteTitle}}</strong>.',
    'remove_website_done': 'Website removed.',
    'remove_website_failed': 'Failed to remove <strong>{{websiteTitle}}</strong>.',
    'remove_website_canceled': 'Removing <strong>{{websiteTitle}}</strong> is canceled.',
    'deactivate_website_pending': 'Deactivating <strong>{{websiteTitle}}</strong>.',
    'deactivate_website_running': 'Deactivating <strong>{{websiteTitle}}</strong>.',
    'deactivate_website_done': '<strong>{{websiteTitle}}</strong> deactivated.',
    'deactivate_website_failed': 'Failed to deactivate <strong>{{websiteTitle}}</strong>.',
    'deactivate_website_canceled': 'Deactivating <strong>{{websiteTitle}}</strong> is canceled.',
    'wp_core_update_pending': 'Updating WordPress on <strong>{{websiteTitle}}</strong>.',
    'wp_core_update_running': 'Updating WordPress on <strong>{{websiteTitle}}</strong>.',
    'wp_core_update_done': 'Wordpress on <strong>{{websiteTitle}}</strong> is updated.',
    'wp_core_update_failed': 'Failed to update WordPress on <strong>{{websiteTitle}}</strong>.',
    'wp_core_update_canceled': 'Updating WordPress on <strong>{{websiteTitle}}</strong> is canceled.',
    'install_pending': 'Installing {{productTitle}}.',
    'install_running': 'Installing {{productTitle}}.',
    'install_done': '{{productTitle}} installed.',
    'install_failed': 'Failed to install {{productTitle}}.',
    'install_canceled': 'Installing {{productTitle}} is canceled.',
    'install_activate_pending': 'Installing {{productTitle}}.',
    'install_activate_running': 'Installing {{productTitle}}.',
    'install_activate_done': '{{productTitle}} installed.',
    'install_activate_failed': 'Failed to install {{productTitle}}.',
    'install_activate_canceled': 'Installing {{productTitle}} is canceled.',
    'update_pending': 'Updating {{productTitle}}.',
    'update_running': 'Updating {{productTitle}}.',
    'update_done': '{{productTitle}} updated.',
    'update_failed': 'Failed to update {{productTitle}}.',
    'update_canceled': 'Updating {{productTitle}} is canceled.',
    'deactivate_delete_pending': 'Deleting {{productTitle}}.',
    'deactivate_delete_running': 'Deleting {{productTitle}}.',
    'deactivate_delete_done': '{{productTitle}} deleted.',
    'deactivate_delete_failed': 'Failed to delete {{productTitle}}.',
    'deactivate_delete_canceled': 'Deleting {{productTitle}} is canceled.',
    'activate_pending': 'Activating {{productTitle}}.',
    'activate_running': 'Activating {{productTitle}}.',
    'activate_done': '{{productTitle}} activated.',
    'activate_failed': 'Failed to activate {{productTitle}}.',
    'activate_canceled': 'Activating {{productTitle}} is canceled.',
    'deactivate_pending': 'Deactivating {{productTitle}}.',
    'deactivate_running': 'Deactivating {{productTitle}}.',
    'deactivate_done': '{{productTitle}} deactivated.',
    'deactivate_failed': 'Failed to deactivate {{productTitle}}.',
    'deactivate_canceled': 'Deactivating {{productTitle}} is canceled.',
    'upload_pending': 'Uploading product.',
    'upload_running': 'Uploading product.',
    'upload_done': 'Product uploaded.',
    'upload_failed': 'Failed to upload product.',
    'upload_canceled': 'Product upload canceled.',
    'run_job_pending': 'Backup is in progress.',
    'run_job_running': 'Backup is running.',
    'run_job_done': 'Backup is finished.',
    'run_job_failed': 'Failed to backup.',
    'run_job_canceled': 'Backup is in progress is canceled.',
    'backup_pending': 'Backup is in progress.',
    'backup_running': 'Backup is running.',
    'backup_done': 'Backup is finished.',
    'backup_failed': 'Failed to backup.',
    'backup_canceled': 'Backup is in progress is canceled.',
    'restore_pending': 'Backup restoration is in progress.',
    'restore_running': 'Backup restoration is in progress.',
    'restore_done': 'Backup restored.',
    'restore_failed': 'Failed to restore backup.',
    'restore_canceled': 'Backup restoration is in progress is canceled.',
    'process_download_pending': 'Downloading backup.',
    'process_download_running': 'Downloading backup.',
    'process_download_done': 'Backup download finished.',
    'process_download_failed': 'Failed to download backup.',
    'process_download_canceled': 'Downloading backup is canceled.',
    'optimize_pending': 'Optimizing images.',
    'optimize_running': 'Optimizing images.',
    'optimize_done': 'Images optimization finished.',
    'optimize_failed': 'Images optimization failed.',
    'optimize_canceled': 'Optimizing images is canceled.',
    'performance_check_pending': 'Performance check is in progress.',
    'performance_check_running': 'Performance check is in progress.',
    'performance_check_done': 'Performance check finished.',
    'performance_check_failed': 'Performance check failed.',
    'performance_check_canceled': 'Performance check is in progress is canceled.',
    'run_scan_pending': 'Security scan is in progress.',
    'run_scan_running': 'Security scan is in progress.',
    'run_scan_done': 'Security scan finished.',
    'run_scan_failed': 'Security scan failed.',
    'run_scan_canceled': 'Security scan is in progress is canceled.',
    'install_template_running': 'Installing Template is in progress.',
    'install_template_pending': 'Installing Template is in progress.',
    'install_template_done': 'Installing Template finished.',
    'install_template_failed': 'Installing Template failed.',
    'install_template_canceled': 'Installing Template canceled.',
    'install_hosted_template_running': 'Installing Template is in progress.',
    'install_hosted_template_pending': 'Installing Template is in progress.',
    'install_hosted_template_done': 'Installing Template finished.',
    'install_hosted_template_failed': 'Installing Template failed.',
    'install_hosted_template_canceled': 'Installing Template canceled.',
    'install-activate_update_running': 'Installing {{productTitle}}.',
    'install-activate_update_pending': 'Installing {{productTitle}}.',
    'install-activate_update_done': '{{productTitle}} installed.',
    'install-activate_update_failed': 'Failed to install {{productTitle}}.',
    'ai_create_website_running': 'Installing 10WebX Template is in progress.',
    'ai_create_website_pending': 'Installing 10WebX Template is in progress.',
    'ai_create_website_done': 'Installing 10WebX Template finished.',
    'ai_create_website_failed': 'Installing 10WebX Template failed.',
    'ai_create_website_canceled': 'Installing 10WebX Template canceled.',
    'push_to_live_running': 'Push to live',
    'push_to_live_pending': 'Push to live',
    'push_to_live_done': 'Push to live',
    'push_to_live_failed': 'Push to live',
    'push_to_live_canceled': 'Push to live',
    'push_to_staging_running': 'Push to staging',
    'push_to_staging_pending': 'Push to staging',
    'push_to_staging_done': 'Push to staging',
    'push_to_staging_failed': 'Push to staging',
    'push_to_staging_canceled': 'Push to staging',
    'first_page_is_optimizing_running': 'Connecting your website',
    'first_page_is_optimizing_pending': 'Connecting your website',
    'first_page_is_optimizing_done': 'Connecting your website',
    'first_page_is_optimizing_failed': 'Connecting your website',
    'first_page_is_optimizing_canceled': 'Connecting your website',
    'page_speed_score_running': 'Checking website score',
    'page_speed_score_pending': 'Checking website score',
    'page_speed_score_done': 'Checking website score',
    'page_speed_score_failed': 'Checking website score',
    'page_speed_score_canceled': 'Checking website score'
  };

  public static map(data: any): IActivityNotification {
    const activityNotification: IActivityNotification = <IActivityNotification>{};

    activityNotification.id = data.id || (data._id && data._id.$oid) || '';
    activityNotification.websiteId = parseInt(data.domain_id);
    activityNotification.service = data.service;
    activityNotification.type = data.type;
    activityNotification.action = data.action;
    activityNotification.date = data.created_at && data.created_at.$date ? new Date(data.created_at.$date) : new Date();
    activityNotification.isNew = !Utils.isTruthy(data.viewed);
    activityNotification.status = data.status;
    activityNotification.message = data.message;
    activityNotification.progress = [ActivityNotificationStatus.DONE, ActivityNotificationStatus.FAILED].includes(data.status) ? 100 : data.progress;
    activityNotification.meta = data.meta_data ? data.meta_data : (data.meta ? JSON.parse(data.meta) : null);

    return activityNotification;
  }

  public static generateActivityNotificationMessage(action: string, status: string, websiteTitle: string, productTitle: string, migratingWebsite: boolean = false): string {
    let message: string;

    if (migratingWebsite) {
      message = 'Migrating Website';
    }
    else {
      if ([ActivityAction.INSTALL, ActivityAction.INSTALL_ACTIVATE, ActivityAction.INSTALL_ACTIVATE_UPLOAD].includes(<any>action) && !productTitle) {
        // uploading
        message = ActivityNotificationMapper.activityNotificationMessages['upload' + '_' + status];
      }
      else {
        message = ActivityNotificationMapper.activityNotificationMessages[action + '_' + status];
      }

      if (message) {
        message = message.split('{{websiteTitle}}').join(websiteTitle || '');
        message = message.split('{{productTitle}}').join(productTitle || 'Product');
      }
    }

    return message;
  }

}
